import { CheckboxItems } from '@own/fds-react/dist/types/checkbox.types';
import { FmCheckbox } from '../../../../common/fm-checkbox/fm-checkbox';

export const DisabledCheckboxes: React.FC<{
    disabledCategories: CheckboxItems[] | null;
}> = props => {
    return (
        <>
            {props.disabledCategories && (
                <div
                    className="hidden-categories-checkboxes checkbox-section"
                    data-testid="hidden-categories-checkboxes"
                >
                    <FmCheckbox
                        checkboxArray={props.disabledCategories}
                        direction="standard"
                    />
                </div>
            )}
        </>
    );
};
